import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcAlarm(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.75 12.696V8.75a.73.73 0 0 0-.216-.534.73.73 0 0 0-.535-.216.73.73 0 0 0-.534.216.73.73 0 0 0-.216.534v4.177q0 .18.066.344.065.164.205.304l2.925 2.925q.209.209.522.213a.7.7 0 0 0 .532-.213.72.72 0 0 0 .217-.527.72.72 0 0 0-.217-.527zM12 21.5a8.3 8.3 0 0 1-3.316-.67 8.6 8.6 0 0 1-2.696-1.818 8.6 8.6 0 0 1-1.82-2.697A8.3 8.3 0 0 1 3.5 13q0-1.77.67-3.315a8.6 8.6 0 0 1 1.819-2.696 8.6 8.6 0 0 1 2.696-1.82 8.3 8.3 0 0 1 3.315-.669q1.77 0 3.316.67a8.6 8.6 0 0 1 2.696 1.819 8.6 8.6 0 0 1 1.819 2.696q.67 1.546.67 3.315 0 1.77-.67 3.316a8.6 8.6 0 0 1-1.82 2.696 8.6 8.6 0 0 1-2.696 1.819A8.3 8.3 0 0 1 12 21.5M2.414 7.28a.72.72 0 0 1-.218-.526q0-.31.218-.527l2.811-2.811a.73.73 0 0 1 .522-.213.7.7 0 0 1 .532.213q.217.216.217.526a.72.72 0 0 1-.217.527L3.468 7.281a.73.73 0 0 1-.522.212.7.7 0 0 1-.531-.212m19.169 0a.72.72 0 0 1-.527.218.72.72 0 0 1-.527-.217l-2.812-2.812a.72.72 0 0 1-.212-.522.7.7 0 0 1 .212-.531.72.72 0 0 1 .527-.218q.31 0 .527.218l2.812 2.811q.207.208.212.522a.7.7 0 0 1-.212.532M11.999 20q2.915 0 4.958-2.042 2.042-2.043 2.042-4.958t-2.042-4.958T11.999 6 7.041 8.042Q5 10.085 5 13t2.042 4.958Q9.084 20 12 20"
  }));
}
var IcAlarm = createNolIcon(/*#__PURE__*/forwardRef(SvgIcAlarm));

export { IcAlarm as I };
